import * as yup from "yup";

export const CREATE_REFERENCE_VALUE_INITIAL = {
  name: "",
  description: "",
  effectiveDate: "",
};
export const CREATE_REFERENCE_VALUE_VALIDATION_SCHEMA = yup.object({
  name: yup.string().required("Name is a required field."),
  description: yup.string().required("Description is a required field."),
  effectiveDate: yup.object().required("Effective Date is a required field."),
});

export const DSDE_REFERENCE_LIST_COLUMN_DATA = [
  { title: "Value", key: "name", dataIndex: "name" },
  {
    title: "Value Description",
    key: "description",
    dataIndex: "description",
  },
  {
    title: "Start Date",
    key: "start_date",
    dataIndex: "start_date",
  },
  {
    title: "End Date",
    key: "end_date",
    dataIndex: "end_date",
  },
];

export const DSDE_MAPPING_INITIAL_VALUES = {
  dataSource: "",
  tableName: "",
  columnName: "",
  datatype: "",
  columnLength: "",
  pattern: "",
  uniqueFlag: false,
  isSecured: false,
  phi: "phi",
};

export const DSDE_MAPPING_VALIDATION_SCHEMA = yup.object({
  tableName: yup.object().required("Table Name is required"),
  columnName: yup.object().required("Column Name is required"),
});

export const DSDE_REFERENCE_LIST_ROW_DATA = [
  {
    name: "Language",
    value: "aa",
    valueDescription: "afar",
    effectiveStartDate: "1899-12-31",
    effectiveEndDate: "1899-12-31",
  },
  {
    name: "Language",
    value: "aa",
    valueDescription: "afar",
    effectiveStartDate: "1899-12-31",
    effectiveEndDate: "1899-12-31",
  },
  {
    name: "Language",
    value: "aa",
    valueDescription: "afar",
    effectiveStartDate: "1899-12-31",
    effectiveEndDate: "1899-12-31",
  },
];

export const MINIMUM_PAGE_SIZE = 10;

export const REFERENCE_SOURCE_EXPLORE_PAGE_URL = id =>
  `/management/reference-data/reference-sources/${id}`;
